import OnSelectedEntryHandler from '../Events/OnSelectedEntryHandler';
import { EngineEvents } from '../../../../services/wss/events/EngineEvents';

/**
 * Creates the handler map for TopicGroupEngine.
 * Add new engine event handlers here — _onEvent picks them up automatically.
 * @param {TopicGroupCache} cache
 * @param {TopicGroupSaver} saver
 * @returns {Object} handler map keyed by EngineEvents
 */
export const createHandlers = (cache, saver) => ({
    [EngineEvents.onSelectedEntry]: new OnSelectedEntryHandler(cache, saver),
});
